<template>
  <button @click="handleClick" :disabled="disabled || loading" id="m-button" :class="getClasses()">
    <md-icon v-if="icon" class="m-btn-icon">{{icon}}</md-icon>
    <div v-if="loading" class="loader-rolling-local_white"/>
    <span v-else-if="btnText">{{format(btnText)}}</span>
    <md-icon v-if="trailingIcon" class="m-btn-icon">{{trailingIcon}}</md-icon>
    <md-tooltip
      md-direction="top"
      v-if="tooltip"
    >{{tooltip}}</md-tooltip>
  </button>
</template>


<script>
// Example usage
//  <moow-button :type="['light', 'outlined', 'flat']" btnText="Testing" icon="edit"></moow-button>

export default {
  props: {
    highlighted: {
      type: Boolean,
      default: false
    },
    trailingIcon: {
      type: [Boolean, String],
      default: false
    },
    tooltip: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Array,
      required: false,
    },
    btnText: {
      type: String,
      required: false,
    },
    camel: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false
    }
  },
  components: {},
  data() {
    return {};
  },
  filters: {},
  computed: {},
  mounted() {},
  created() {},
  methods: {
    handleClick(payload) {
      this.$emit("mClick", payload);
    },
    getClasses() {
      var valueHolder;
      if (this.type.includes("toggle")) {
        valueHolder = "moow-toggle ";
        if (this.type.includes("left")) valueHolder += "left ";
        else if (this.type.includes("right")) valueHolder += "right ";
        return valueHolder;
      }
      valueHolder = "moow-btn ";
      if (this.disabled) valueHolder += "m-disabled ";
      if (this.type.includes("light")) valueHolder += "m-light ";
      else if (this.type.includes("dark")) valueHolder += "m-dark ";
      else if (this.type.includes("blue")) valueHolder += "m-blue ";
      else if (this.type.includes("white")) valueHolder += "m-white ";
      if (this.type.includes("fab")) valueHolder += "m-fab ";
      if (this.type.includes("small")) valueHolder += "m-small ";
      else if (this.type.includes("large")) valueHolder += "m-large ";
      if (this.type.includes("outlined")) valueHolder += "m-outlined ";
      if (this.type.includes("flat")) valueHolder += "m-flat ";
      if (this.type.includes("wide")) valueHolder += "m-wide ";
      if (this.type.includes("link")) valueHolder += "m-link ";
      if (this.type.includes("fat")) valueHolder += "m-fat ";
      if (this.icon) valueHolder += "m-icon ";
      
      if (this.trailingIcon) valueHolder += "flex-row-reverse ";
      if(this.highlighted) valueHolder += "highlighted"


      return valueHolder.trim();
    },
    format: function (value) {
      if (!value) return value;
      if (!this.camel) return value.toUpperCase();
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../../assets/styles/variables.scss";


.moow-toggle {
  padding: 0 1em;
  width: 150px;
  border-color: $play-dark;
  border: 0px;
  padding: 0.6em 1.5em 0.6em 1.5em;
  font-weight: 500;
  border-radius: 16px;
  color: $play-dark;
  background-color: white;
}

@media (max-width: 1000px) {
  .moow-toggle {
    width: 100px;
  }
}

.moow-toggle.left {
  border-radius: 8px 0px 0px 8px;
  margin-right: 0px;
  border-width: 1px 0px 1px 1px;
}

.moow-toggle.right {
  border-radius: 0px 8px 8px 0px;
  margin-left: 0px;
  border: 1px solid #F1F4F8;
  border-width: 1px 1px 1px 0px;
}

.m-btn-icon {
  margin-right: 7px;
  margin-left: 3px;
  color: white !important;
  animation-duration: 4s;
}
// .moow-btn.m-light .m-btn-icon {
//   color: $old-makeup-pink !important;
// }

.moow-btn.m-dark .m-btn-icon {
  color: $play-dark !important;
}
// .moow-btn.m-blue .m-btn-icon {
//   color: $play-blue-light !important;
// }

.moow-btn.m-link .m-btn-icon {
  padding: 0;
  margin: 0;
  width: auto;
  margin: 10px;
  text-decoration: none !important;
}


.moow-btn {
  display: inline;
  // margin-left: 1em;
  box-shadow: 0px 10px 64px rgba(11, 11, 11, 0.06);
  border-radius: 8px;
  font-weight: 700;
  border: 0px;
  padding: 0.6em 1.5em 0.6em 1.5em;
  transition: box-shadow 0.1s ease-in-out, opacity 0.4s ease-in-out;
  -webkit-transition: box-shadow 0.1s ease-in-out, opacity 0.4s ease-in-out;
  -moz-transition: box-shadow 0.1s ease-in-out, opacity 0.4s ease-in-out;
  -ms-transition: box-shadow 0.1s ease-in-out, opacity 0.4s ease-in-out;
  -o-transition: box-shadow 0.1s ease-in-out, opacity 0.4s ease-in-out;
}

.moow-btn.m-large {
  font-weight: 500;
  font-size: 19px;
  padding: 0.1em 1.5em 0.1em 1.5em;
  line-height: 40px;
}

.moow-btn.m-fat {
  min-height: 46px;
  padding: 0.1em 1.5em 0.1em 1.5em;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  border-radius: 30px;
}

.m-fab{
  border-radius: 16px;
  width: 50px;
  height: 50px;
  text-align: center;
  padding: 0 !important;
}

.m-fab.m-small{
  width: 50px;
  height: 50px;
  border-radius: 50px;
  text-align: center;
  padding: 0 !important;
}

.m-fab.m-flat{
  border: none;
}


.m-fab .m-btn-icon{
  margin: 0 auto;
}

.moow-btn:active {
  box-shadow: none !important;
}

.moow-btn.m-icon {
  padding: 0.6em 1.5em 0.6em 0.6em;
}

.moow-btn:hover {
  opacity: 0.9;
  box-shadow: 0 4px 5px 1px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  //   transition: box-shadow 0.1s ease-in-out, opacity 0.5s ease-in-out;
  //   -webkit-transition: box-shadow 0.1s ease-in-out, opacity 0.5s ease-in-out;
  //   -moz-transition: box-shadow 0.1s ease-in-out, opacity 0.5s ease-in-out;
  //   -ms-transition: box-shadow 0.1s ease-in-out, opacity 0.5s ease-in-out;
  //   -o-transition: box-shadow 0.1s ease-in-out, opacity 0.5s ease-in-out;
}

.moow-btn.m-flat {
  box-shadow: none;
}

.moow-btn.m-dark {
  background-color: $play-dark;
  color: white;
}
.moow-btn.m-blue {
  background-color: $play-blue-light;
  color: white;
}
.moow-btn.m-light {
  background-color: $old-makeup-pink;
  color: white;
}

.moow-btn.m-white {
  background-color: white;
  color: #30404A;
  border: 0px;
}

.moow-btn.m-white i{
  color: #30404A !important;
}


.moow-btn.m-wide {
    width: 100%;
    margin-left: 1em;
    margin-right: 1em;
}

.moow-btn.m-link {
  text-align: left;
  padding: 0;
  margin: 0;
  border: none;
  color:$old-makeup-pink;
  background: transparent;
  box-shadow: none;
}
.moow-btn.m-link span {
  text-decoration: underline;
}
.moow-btn.m-blue.m-link {
    border: none;
    text-decoration: underline;
    color: $play-blue-light;
    background: transparent;
    box-shadow: none;
}
.moow-btn.m-dark.m-link {
    border: none;
    text-decoration: underline;
    color: #757575;
    background: transparent;
    box-shadow: none;
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 50px;
    /* or 333% */
    text-decoration-line: underline;
}

.moow-btn.m-light.m-outlined {
  color: $old-makeup-pink;
  border: solid 1px $old-makeup-pink;
  background-color: white !important;
}

.moow-btn.m-dark.m-outlined {
  color: $play-dark;
  border: solid 1px $play-dark;
  background-color: white;
}
.moow-btn.m-blue.m-outlined {
  color: $play-blue-light;
  border: solid 1px $play-blue-light;
  background-color: white;
}

.moow-btn.m-disabled {
  border: solid 1px grey !important;
  color: grey !important;
  box-shadow: none !important;
  background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/interface/buttons/moowButton.vue